import React, { memo } from 'react';
import PropTypes from 'prop-types';

function BrandRadarStats({ nodes, links }) {
  return (
    <div className="BrandRadar-count">
      {nodes} brands · {links} connections
    </div>
  );
}

BrandRadarStats.propTypes = {
  nodes: PropTypes.number.isRequired,
  links: PropTypes.number.isRequired,
};

export default memo(BrandRadarStats);
